import styled from '@emotion/styled'
export const StyleGrid = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(8, 1fr);
  @media (max-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }
`

export const StyleGridItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: center;
  position: relative;
`

export const StyleCheckedIconWrapper = styled.div`
  position: absolute;
  top: -3px;
  right: -9px;
`
export const StyleWrapper = styled.div`
  position: relative;
`
export const StyleSearchWrapper = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  border-radius: 8px;
  padding: 0px 10px;
  padding-bottom: 10px;
  position: absolute;
  width: 100%;
  top: 50px;
  z-index: 111;
  max-height: 250px;
  background: white;
  overflow-y: auto;
`

export const StyleSearchItem = styled.div`
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 15px 10px;
  display: flex;
  align-items: center;
  column-gap: 10px;
`

export const StyleSearch = styled.div`
  display: flex;
`

export const StyleInputWrapper = styled.div`
  position: relative;
  display: flex;
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 0px 10px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 45px;
  width: 100%;
`
export const StyleInput = styled.input`
  height: 43px;
  padding: 0px;
  margin: 0px;
  outline: none;
  font-size: 14px;
  border: 0px;
  text-indent: 10px;

  &::placeholder {
    font-size: 14px;
    color: ${(props: any) => props.theme.colors.placeholder};
    font-weight: 400;
  }
`
export const StyleIconWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
`
